<template>
  <div>
    <div class="error-page">
        <h2 class="headline text-red">404</h2>

        <div class="error-content">
          <h3><i class="fa fa-warning text-red"></i> Página não encontrada.</h3>
          <p>
            Clique <router-link :to="{ name: 'Homepage' }" exact><a> <span>aqui</span></a></router-link> para continuar da página inicial
          </p>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: 'NotFoundError'
}
</script>



// WEBPACK FOOTER //
// NotFoundError.vue?10ba699e